"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@emotion/core");
var styled_1 = __importDefault(require("@emotion/styled"));
var resize = core_1.keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  0%, 50% {\n    height: 0;\n  }\n\n  25% {\n    height: 100%;\n  }\n"], ["\n  0%, 50% {\n    height: 0;\n  }\n\n  25% {\n    height: 100%;\n  }\n"])));
var barSizes = [
    "40%",
    "70%",
    "100%",
    "70%",
    "40%",
];
var createBarAnimationCSS = function (sizes, duration) {
    if (duration === void 0) { duration = 1; }
    var styles = "";
    sizes.forEach(function (size, idx) {
        styles += "\n      &:nth-of-type(" + (idx + 1) + ") {\n        max-height: " + size + ";\n        animation-delay: " + (0.5 * duration * idx) / sizes.length + "s;\n      }\n    ";
    });
    return styles;
};
exports.Loader = styled_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background: ", ";\n  width: 0.8125rem;\n  margin: 0 0.125rem;\n  animation: ", " 1s infinite linear;\n\n  ", "\n"], ["\n  background: ", ";\n  width: 0.8125rem;\n  margin: 0 0.125rem;\n  animation: ", " 1s infinite linear;\n\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.primary;
}, resize, createBarAnimationCSS(barSizes));
var templateObject_1, templateObject_2;
